import React from 'react'
import './NavBarSecondaryMobile.css'
import ExpandMore from '@mui/icons-material/ExpandMore'
import {
  ClickAwayListener,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Stack,
  Button
} from '@mui/material'
import Headroom from 'react-headroom'
import { INavTabProps } from '../../interface'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

export default function NavBarSecondaryMobile(props: any) {
  const [expanded, setExpanded] = React.useState(false)
  const navHeight = 72
  const handleChange = () => setExpanded(expanded ? false : true)
  const handleClickAway = () => {
    setExpanded(false)
  }

  return (
    <Headroom data-gtm-click-section='Secondary Nav' style={{ top: 'auto', zIndex: 99, height: navHeight }}>
      <ClickAwayListener onClickAway={handleClickAway}>
        <Accordion
          expanded={expanded}
          onChange={handleChange}
          sx={{
            bgcolor: '#282828',
            borderRadius: 0,
            minHeight: navHeight
          }}
        >
          <AccordionSummary
            sx={{ px: 2, py: 0, height: navHeight }}
            expandIcon={<ExpandMore sx={{ color: '#bbb', minHeight: 60 }} />}
          >
            <Stack>
              <Typography sx={{ color: '#fff', textTransform: 'uppercase', fontWeight: 400 }}>{props.title}</Typography>
              <img width={props.logoWidth} alt={props.logoAlt} src={props.logo} />
            </Stack>
          </AccordionSummary>
          <AccordionDetails sx={{ p: 0, pb: 3 }}>
            <ul className='nav-secondaryMobile-ul'>
              {props.navBarSecondaryTab.map((navTab: INavTabProps, index: number) => (
                <Link onClick={handleClickAway} to={navTab.url} key={index}>
                  {navTab.label}
                  {navTab.new === true && (
                    <Typography color='primary.light' variant='body2' sx={{ fontWeight: 500, ml: 1.5 }}>
                      <FormattedMessage id='common.new' />
                    </Typography>
                  )}
                </Link>
              ))}
            </ul>
            {props.storeURL && (
              <Button
                size='small'
                variant='contained'
                color='secondary'
                sx={{ fontSize: '.75rem', fontWeight: 700, mx: 4, mt: 2, mb: 1 }}
                component={Link}
                to={props.storeURL}
              >
                <FormattedMessage id='common.buyNow' />
              </Button>
            )}
          </AccordionDetails>
        </Accordion>
      </ClickAwayListener>
    </Headroom>
  )
}
